module.exports = __webpack_public_path__ + "img/1440.634c7096.jpg";